import React from "react";
import { FaAppStoreIos } from "react-icons/fa";
import { AiTwotoneAppstore } from "react-icons/ai";
import { SiAntdesign } from "react-icons/si";
import { BiCodeAlt } from "react-icons/bi";
import ServicesCard from "./ServicesCard";

const MyServices = () => {
  const services = [
    {
      icon: <BiCodeAlt className="text-2xl text-blue-400" />,
      title: "Веб-разработка",
      description: "Создание современных веб-приложений на React/Next.js."
    },
    {
      icon: <SiAntdesign className="text-2xl text-purple-400" />,
      title: "Базы данных",
      description: "Проектирование SQL/NoSQL баз данных."
    },
    {
      icon: <AiTwotoneAppstore className="text-2xl text-blue-400" />,
      title: "Мобильная разработка",
      description: "Разработка нативных и гибридных приложений."
    },
    {
      icon: <FaAppStoreIos className="text-2xl text-purple-400" />,
      title: "SEO Оптимизация",
      description: "Комплексный подход к SEO."
    }
  ];

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
      {services.map((service, index) => (
        <ServicesCard
          key={index}
          icons={service.icon}
          title={service.title}
          subTitle={service.description}
        />
      ))}
    </div>
  );
};

export default MyServices;